import { Buffer } from 'buffer';
import { storage, STORAGE_KEYS } from './Storage';

/**
 * Service to handle secure storage of credentials
 * Note: Uses base64 encoding for obfuscation.
 * storage itself has encryptionKey configured in Storage.ts
 */
class SecureStorage {

    /**
     * Save credentials securely
     */
    saveCredentials(username: string, password: string): void {
        try {
            // Simple obfuscation using base64
            const encodedUsername = Buffer.from(username).toString('base64');
            const encodedPassword = Buffer.from(password).toString('base64');

            storage.set(STORAGE_KEYS.SECURE_USERNAME, encodedUsername);
            storage.set(STORAGE_KEYS.SECURE_PASSWORD, encodedPassword);
        } catch (error) {
            console.error('Error saving credentials:', error);
            throw error;
        }
    }

    /**
     * Get stored credentials
     */
    getCredentials(): { username: string; password: string } | null {
        try {
            const encodedUsername = storage.getString(STORAGE_KEYS.SECURE_USERNAME);
            const encodedPassword = storage.getString(STORAGE_KEYS.SECURE_PASSWORD);

            if (encodedUsername && encodedPassword) {
                const username = Buffer.from(encodedUsername, 'base64').toString('utf-8');
                const password = Buffer.from(encodedPassword, 'base64').toString('utf-8');
                return { username, password };
            }
            return null;
        } catch (error) {
            console.error('Error getting credentials:', error);
            return null;
        }
    }

    /**
     * Clear stored credentials
     */
    clearCredentials(): void {
        try {
            storage.delete(STORAGE_KEYS.SECURE_USERNAME);
            storage.delete(STORAGE_KEYS.SECURE_PASSWORD);
        } catch (error) {
            console.error('Error clearing credentials:', error);
            throw error;
        }
    }
}

export default new SecureStorage();
